import { styled } from '@mui/material/styles'
import { IconButton } from '@mui/material'

export const IconButtonWrapper = styled(IconButton)(({ theme }) => (`
  & svg path{
   fill: ${theme.components.MuiIconButton.styleOverrides.color};
  }
`))
